import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

const FieldSelect = (props) => {
    const [allFields, setAllFields] = useState(false);
    const [fieldList, setFieldList] = useState([]);
    const userSettings = useSelector(state => state.userSettingInfo.value);
    useEffect(() => {
      console.log('init field settings');
      console.log(userSettings);
      setFieldList(userSettings.fieldSettings.columns);
    }, []);

    const onChangeField = (field) => {
      let fields = [...fieldList];
      let f = fields.find(fld => fld.colName === field.colName);
      if(f) {
        let idx = fields.indexOf(f);
        f = {...f};
        if(f.show) {
          f.show = false;
        } else {
          f.show = true;
        }
        fields[idx] = f;
        props.toggleFieldDisplay(f);
      }
      setFieldList(fields);
    }

    const onSetAllFields = (all) => {
      setAllFields(all);
      let fields = [...fieldList];
      console.log(fields);
      fields.forEach(field => {
        if(field.display !== all && field.colName !== 'Id')
        {
          let f = fields.find(fld => fld.colName === field.colName);
          if(f) {
            let idx = fields.indexOf(f);
            f = {...f};
            f.display = all;
            fields[idx] = f;
            props.toggleFieldDisplay(f);
          }
        }
      });
      setFieldList(fields);
    }

    return (
    <div className='td-dialogue-container'>
            <div className='td-dialogue card' style={{ width: '400px' }}>
              <div className='card-header'>
                Fields
                <button
                  type='button'
                  className='btn-close'
                  onClick={() => props.close()}
                />
              </div>
              <div
                className='card-body ps-4'
                style={{ maxHeight: '400px', overflow: 'auto' }}
              >
                <strong>Fields:</strong>
                <div className='form-check mb-2'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    checked={allFields}
                    onChange={() => onSetAllFields(!allFields)}
                  />
                  <label className='form-check-label'>Select All:</label>
                </div>
                <div>
                  {fieldList.map((col) => (
                    <div key={col.colName}>
                      {col.colName !== 'Id' && (
                    <div className='form-check'>

                      <input
                        className='form-check-input'
                        type='checkbox'
                        checked={col.show}
                        onChange={() => onChangeField(col)}
                      />

                      <label className='form-check-label ms-1'>{col.displayName ?? col.colName}</label>

                    </div>
                    )}
                    </div>
                  ))}

                </div>
              </div>
            </div>
          </div>
    );
}

export default FieldSelect;